import React, { useState } from "react";

import { triggerTrengo, useTranslation, useUserContext } from "utils";

import { Link } from "components";

export const ContactSupport = () => {
  const { t } = useTranslation("tasks");

  const [trengo, setTrengo] = useState(false);
  const { user } = useUserContext();

  return (
    <p className="margin-0">
      {t("help")}
      <Link onClick={() => triggerTrengo("email", trengo, setTrengo, user)} className="margin-left-50">
        {t("contactSupport")}
      </Link>
    </p>
  );
};
